{
    "AddNotification": "Ajouter une notification",
    "EditNotification": "Modifier la notification",
    "EnableNotification": "Activer la notification",
    "DisableNotification": "Désactiver la notification",
    "NotificationNameBusyTime": "Temps de travail",
    "NotificationNameAvgAnswerTime": "Temps de réponse moyen (secondes)",
    "NotificationNameUserNotLoggedIn7Days": "Utilisateur non connecté depuis 7 jours",
    "NotificationNameMissedCalls": "Appels manqués (#)",
    "NotificationNameUserNeverLoggedIn": "Jamais connecté",
    "NotificationNameWeeklyInsightsReport": "Rapport hebdomadaire",
    "NAME": "NotificationsLanguage"
}